import FormValidation from './form-validation';

class Registration {
  private form: HTMLFormElement | null;
  private submitButton: HTMLButtonElement | null;
  private formValidation: FormValidation;
  private registrationSuccessEvent: CustomEvent;
  private registrationErrorEvent: CustomEvent;

  private async handleRegistrationSubmit() {
    const { form, registrationSuccessEvent, registrationErrorEvent } = this;

    if(form) {
      const apiBaseUrl = document.body.dataset.apiBaseUrl;
      const endpoint = apiBaseUrl ? apiBaseUrl : '/';
      const data = new FormData(form);

      data.append('query_is_lead', '1'); // This plays together with UserRegistrationBehavior::class

      form.classList.add('loading');

      await fetch(endpoint, {
        method: 'post',
        headers: {
          'Accept': 'application/json',
        },
        body: data,
      })
        .then(res => res.json())
        .then((res) => {
          if (res.id && res.id != "") {
            document.dispatchEvent(registrationSuccessEvent);
            this.clearInputFields();

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'sign_up',
              user: {
                email: data.get('email')
              }
            });
            if (res.hasOwnProperty('isNewLead')) {
              window.dataLayer.push({
                event: 'generate_lead',
                lead: {
                  type: 'registration',
                  email: data.get('email'),
                  new_lead: res.isNewLead ? 'Yes' : 'No'
                }
              });
            }
          } else {
            throw new Error(JSON.stringify(res.errors));
          }
        })
        .catch((error) => {
          document.dispatchEvent(registrationErrorEvent);
          console.error(error);
        });

      form.classList.remove('loading');
    }
  }

  private createRegistrationSuccessEvent() {
    this.registrationSuccessEvent = new CustomEvent('formpopup:open', {
      detail: {
        form: 'registration-success',
        type: 'form',
        size: 'large',
        target: 'form-popup'
      },
    } as any);
  }

  private createRegistrationErrorEvent() {
    this.registrationErrorEvent = new CustomEvent('formpopup:open', {
      detail: {
        form: 'registration-error',
        type: 'form',
        size: 'large',
        target: 'form-popup'
      },
    } as any);
  }

  private clearInputFields() {
    const { form } = this;

    if(form) {
      form.querySelectorAll('input').forEach( (input: HTMLInputElement) => {
        input.value = '';
        input.checked = false;
      });
      form.querySelectorAll('select').forEach( (select: HTMLSelectElement) => {
        select.value = '';
      });

    }
  }

  bindings() {
    const { form, submitButton } = this;

    if(form) {
      this.formValidation = new FormValidation(
        form,
        this.handleRegistrationSubmit.bind(this)
      );
      this.formValidation.init();
    }
  }

  cache() {
    this.form = document.querySelector('.js-registration-form');
    this.submitButton = this.form?.querySelector('.o-checkout__v1__submit-button button') ?? null;
  }

  init() {
    this.cache();
    this.bindings();
    this.createRegistrationSuccessEvent();
    this.createRegistrationErrorEvent();
  }
}

export default Registration;
